/**
 * Tabbed Forms
 */
(() => {
  document.querySelectorAll('.tabbed-forms__header button')
    .forEach((button) => {
      button.addEventListener('click', () => {
        const dataId = button.getAttribute('data-id');
        const tabbedFormsContent = document.querySelectorAll('.tabbed-forms__content .form-item');
        tabbedFormsContent.forEach((item) => {
          item.classList.add('hide');
          if (item.getAttribute('data-id') === dataId) {
            item.classList.remove('hide');
          }
        });
      });
    });
})();
